var map = {
	"./a023-short1.jpg": 396,
	"./a023-short2.jpg": 397,
	"./a023-short3.jpg": 398,
	"./a023-short4.jpg": 399,
	"./a023-short5.jpg": 400,
	"./a023-short6.jpg": 401
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3470;